//-================ IMPORTS FOR GENERAL COMPONENT ================-\\
import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { firstValueFrom } from 'rxjs';


//-================ IMPORTS FOR SERVICES ================-\\
import { ContextMenuPRCFINComponent } from '../context-menu-prcfin/context-menu-prcfin.component';


//-================ IMPORTS FOR CONSTANTS ================-\\


//-================ IMPORTS FOR DEPENDENCIES ================-\\
import { TreeNode } from 'primeng/api';
import Swal from 'sweetalert2';


//-================ IMPORTS FOR INTERFACES ================-\\
import { File_Tree_FIN } from 'src/app/Interfaces/Libraries/Library-FIN-int/Tree-Move-FIN.interface';
import { Folder_FIN_Path } from 'src/app/Interfaces/Libraries/Library-FIN-int/Folder_FIN.interface';
import { Response_FIN } from 'src/app/Interfaces/Libraries/Library-FIN-int/Response_FIN.interface';
import { FILE_FIN } from 'src/app/Interfaces/Libraries/Library-FIN-int/File_FIN.interface';


@Component({
    selector: 'app-tree-move-proces-fin',
    templateUrl: './tree-move-proces-fin.component.html',
    styleUrls: ['./tree-move-proces-fin.component.scss', '../../../../../Styles/GlobalStyles.css', '../../../../../Styles/TreeMoveGlobal.scss'],
    standalone: false
})
export class TreeMoveProcesFINComponent extends ContextMenuPRCFINComponent implements OnInit {

  //-============== VARIABLES FOR TREE & SELECTED FILE ===============-\\

  //+===================== INPUTS =====================+\\
  @Input() override FFIN_Select_CM!: FILE_FIN;
  @Input() selectedItems: any[] = [];

  //+===================== OUTPUTS =====================+\\
  @Output() IsMoveFIN = new EventEmitter<boolean>();
  @Output() ShowSideBar = new EventEmitter<boolean>();
  @Output() onPerformMove = new EventEmitter<{ items: any[], destinationNode: TreeNode }>();

  public getTitle(): string {
    if (this.selectedItems && this.selectedItems.length > 1) {
      return `Mover ${this.selectedItems.length} elementos`;
    }
    if (!this.FFIN_Select_CM) return 'Mover';
    const type = this.FFIN_Select_CM.Directory ? 'carpeta' : 'proceso';
    return `Mover ${type} "${this.FFIN_Select_CM.Name}"`;
  }


  //+===================== GENERAL TREE =====================+\\
  public loading: boolean = false;
  public files: Folder_FIN_Path[] = [];
  public treeNodes: TreeNode[] = this.files.map(file => {
    return {
      "label": 'Raiz',
      "data": '',
      "expandedIcon": 'fa-solid fa-folder-open',
      "collapsedIcon": "fa-solid fa-folder",
      "leaf": false,
      "children": [{
        "label": file.Name,
        "data": file.Path,
        "expandedIcon": 'fa-solid fa-folder-open',
        "collapsedIcon": "fa-solid fa-folder",
        "leaf": false,
        "children": []
      }]
    };
  });
  public files2: File_Tree_FIN[] = [];
  public selectedFile: any;


  constructor(private cd: ChangeDetectorRef) {
    super();
  }

  override async ngOnInit() {
    this.LoadTree('');
  }


  //&===================== FUNCTIONS FOR LOAD COMPONENT =====================&\\

  //-================== FUNCTTION FOR LOAD TREE ==================-\\
  public async LoadTree(Path: ''): Promise<void> {
    try {

      this.loading = true;

      const ResDirectories: Response_FIN = await firstValueFrom(this.Service_FIN.Get_Dirs_In_Directory_FIN({ path: Path }));

      if (ResDirectories.success) {

        this.files = ResDirectories.operation;
        this.treeNodes = this.files.map((file: Folder_FIN_Path) => this.mapFileNode(file));
        this.loading = false;
        this.cd.markForCheck();

      }


    } catch (e) {
      Swal.fire({
        title: 'Ocurrió un error',
        text: '¡Notifique este error al supervisor!',
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      })
    }

  }

  //&===================== END FUNCTIONS FOR LOAD COMPONENT =====================&\\



  //&===================== FUNCTIONS FOR GENERAL COMPONENT =====================&\\

  //-================== FUNCTTION NODE EXPAND IN TREE ==================-\\
  public async nodeExpand(event: any): Promise<void> {

    const Node: TreeNode = event.node;

    if (!Node) {
      return;
    }

    if ((Node as any).__childrenLoaded) {
      Node.expanded = true;
      return;
    }

    this.loading = true;

    try {

      const childs_response: Response_FIN = await firstValueFrom(this.Service_FIN.Get_Dirs_In_Directory_FIN({ path: Node.data }));

      if (childs_response.success) {

        const Directories: Folder_FIN_Path[] = childs_response.operation;
        const newChildNodes: TreeNode[] = Directories.map((childFile: Folder_FIN_Path) => this.mapFileNode(childFile));

        this.updateTreeNodeChildren(this.treeNodes, Node.data, newChildNodes);
        Node.children = newChildNodes;
        Node.leaf = newChildNodes.length === 0;
        Node.expanded = true;
        (Node as any).__childrenLoaded = true;

        // Render profundo para que PrimeNG pinte hijos en el primer clic.
        this.treeNodes = this.cloneTreeNodes(this.treeNodes);
        this.cd.detectChanges();
      }


    } catch (e) {

      Swal.fire({
        title: 'Ocurrió un error',
        text: '¡Notifique este error al supervisor!',
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      })
    } finally {
      this.loading = false;
    }
  }

  //-================== FUNCTTION FOR MAP DIRECTORY ==================-\\
  private mapFileNode(file: Folder_FIN_Path): TreeNode {
    return {
      label: file.Name,
      data: file.Path,
      expandedIcon: "fa-solid fa-folder-open",
      collapsedIcon: "fa-solid fa-folder",
      leaf: false,
      children: []
    };
  }

  //-================== FUNCTTION FOR SET CHILDREN DIRECTORY ==================-\\
  private updateTreeNodeChildren(nodes: TreeNode[], nodeData: string, newChildNodes: TreeNode[]): void {
    for (const node of nodes) {
      if (node.data === nodeData) {
        node.children = newChildNodes;
        return;
      }

      if (node.children && node.children.length > 0) {
        this.updateTreeNodeChildren(node.children, nodeData, newChildNodes);
      }
    }
  }

  private cloneTreeNodes(nodes: TreeNode[]): TreeNode[] {
    return nodes.map((node: TreeNode) => {
      const children: TreeNode[] = Array.isArray(node.children) ? this.cloneTreeNodes(node.children) : [];
      return {
        ...node,
        children
      };
    });
  }

  //&===================== END FUNCTIONS FOR GENERAL COMPONENT =====================&\\




  //&===================== FUNCTIONS FOR SAVE OR CANCEL =====================&\\

  //-================== FUNCTTION FOR MOVE PROCESS ==================-\\
  public async Move_Process_to_Directorie(): Promise<void> {
    if (!this.selectedFile) {
      Swal.fire({
        title: "Sin carpeta destino",
        text: "Por favor seleccione una carpeta para moverlo",
        icon: "info"
      });
      return;
    }

    const itemsToMove = (this.selectedItems && this.selectedItems.length > 0)
      ? this.selectedItems
      : [this.FFIN_Select_CM];

    this.onPerformMove.emit({ items: itemsToMove, destinationNode: this.selectedFile });
    this.Cancel_Movement();
  }

  //-================== FUNCTTION FOR CANCEL MOVE ==================-\\
  public async Cancel_Movement(): Promise<void> {

    this.ShowSideBar.emit(false);

    this.files = [
      {
        ID: 0,
        Name: '',
        ID_Folder_Top: 0,
        status: 0,
        Directory: false,
        Inheritance: 0,
        InheritanceGA: 0,
        Optional_Approvers: 0,
        Path: ''
      }
    ];

    this.selectedFile = undefined;

    await this.LoadTree('');

    this.cd.markForCheck();
  }

  //&===================== END FUNCTIONS FOR SAVE OR CANCEL =====================&\\
}
